/* eslint-disable no-underscore-dangle */
import { createEmptyEditorState, convertHtmlToEditorState } from '../utils/html-utils';
import {
  MY_FORM_FIELD_HTML,
  MY_FORM_FIELD_SELECT_AUTOCOMPLETE,
  MY_FORM_FIELD_SELECT_MULTIPLE,
  MY_FORM_FIELD_IMAGE,
  MY_FORM_FIELD_IMAGE_MULTIPLE,
  MY_FORM_FIELD_DATE,
  MY_FORM_FIELD_TIME,
  MY_FORM_FIELD_COORDINATE,
  MY_FORM_FIELD_CHECKBOX,
} from './form-constants';
import { convertDateCustomToDate, convertTimeCustomToTime } from '../intl/intl-helpers';

const prepareFormikInitialValues = (iValues, isCreate, fields) => {
  const temp = {};
  if (!iValues) {
    Object.entries(fields).map(([key, field]) => {
      if (isCreate && field.isEditOnly) return key;
      if (field.type === MY_FORM_FIELD_HTML) {
        temp[field.name] = createEmptyEditorState();
      } else if (field.type === MY_FORM_FIELD_SELECT_MULTIPLE) {
        temp[field.name] = [];
      } else if (field.type === MY_FORM_FIELD_IMAGE_MULTIPLE) {
        temp[field.name] = [];
      } else if (field.type === MY_FORM_FIELD_DATE || field.type === MY_FORM_FIELD_TIME) {
        temp[field.name] = null;
      } else if (field.type === MY_FORM_FIELD_CHECKBOX) {
        temp[field.name] = false;
      } else {
        temp[field.name] = '';
      }
      return key;
    });
  } else {
    Object.entries(fields).map(([key, field]) => {
      if (field.type === MY_FORM_FIELD_HTML) {
        temp[field.name] = convertHtmlToEditorState(iValues[field.name]);
      } else if (field.type === MY_FORM_FIELD_IMAGE
        || field.type === MY_FORM_FIELD_IMAGE_MULTIPLE) {
        temp[field.name] = iValues[field.name];
        temp[`${field.name}Old`] = iValues[field.name];
      } else if (field.type === MY_FORM_FIELD_DATE) {
        if (typeof iValues[field.name] === 'string') {
          temp[field.name] = new Date(iValues[field.name]);
        } else {
          temp[field.name] = convertDateCustomToDate(iValues[field.name]);
        }
      } else if (field.type === MY_FORM_FIELD_TIME) {
        temp[field.name] = convertTimeCustomToTime(iValues[field.name]);
      } else if (field.type === MY_FORM_FIELD_SELECT_AUTOCOMPLETE) {
        if (iValues[field.name]) {
          temp[field.name] = {
            value: iValues[field.name]._id,
            label: iValues[field.name].name, // TODO: could be trouble here.
          };
        } else {
          temp[field.name] = '';
        }
      } else if (field.type === MY_FORM_FIELD_SELECT_MULTIPLE) {
        temp[field.name] = iValues[field.name].map((v) => `${v._id}:${v.name}`);
      } else if (field.type === MY_FORM_FIELD_COORDINATE) {
        temp[field.name] = `${iValues.lat}:${iValues.lng}`; // TODO: could be trouble here.
      } else {
        temp[field.name] = iValues[field.name];
      }
      if (field.inputProps) {
        if (field.inputProps.type === 'password') {
          temp[field.name] = '';
          temp[`${field.name}Old`] = '';
        }
      }
      return key;
    });
  }
  return temp;
};

export default prepareFormikInitialValues;
